import React, { Component } from "react";
import ArrowLink from "../ArrowLink/ArrowLink";
import "./CarouselCard.scss";
class CarouselCard extends Component {
    state = {
        isContactUsModalOpen: false,
        contactEmail: "",
        contactPhone: "",
        itemId: ""
    }
    contactUsHandler = (e) => {
        this.setState({
            contactEmail: e.currentTarget.querySelector('input.email').value,
            contactPhone: e.currentTarget.querySelector('input.phone').value,
            isContactUsModalOpen: true

        })
    }
    render() {
        const {
            src,
            alt,
            title,
            shortDescription,
            arrowLinkText,
            href,
            loyaltycarousal
        } = this.props

        return (
            <div className={`carousel-card-molecule ${
                loyaltycarousal ? "loyalty-offer" : ""
                }`}>
                <div className="carousel-card">
                    <div className="carousel-image">
                        <img src={src} loading="lazy" alt={alt} />
                    </div>
                    <div className="carousel-content-wrap">
                        <h3>{title}</h3>
                        <div className="carousel-description">{shortDescription}</div>
                        <ArrowLink
                            aText={arrowLinkText}
                            href={href}
                        />

                    </div>
                </div>
            </div>
        );
    }
}
export default CarouselCard;
